import { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { Speaker } from '../../types/speaker';

interface SpeakerSelectProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export function SpeakerSelect({ value, onChange, required }: SpeakerSelectProps) {
  const [speakers, setSpeakers] = useState<Speaker[]>([]);

  useEffect(() => {
    const fetchSpeakers = async () => {
      const q = query(collection(db, 'speakers'), orderBy('name'));
      const querySnapshot = await getDocs(q);
      const speakersData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as Speaker[];
      setSpeakers(speakersData);
    };

    fetchSpeakers();
  }, []);

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-600 mb-1">
        Orateur
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#00665C] focus:border-[#00665C]"
      >
        <option value="">Sélectionner un orateur</option>
        {speakers.map((speaker) => (
          <option key={speaker.id} value={speaker.id}>
            {speaker.name}
          </option>
        ))}
      </select>
    </div>
  );
}